import {
  Component,
  HostListener,
  OnDestroy,
  ViewChild,
  inject,
  output,
} from '@angular/core';
import {
  SiaSessionService,
  SiaSizeDetectorService,
  SiaTranslatePipe,
} from '@sia/shared';
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
} from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import {
  DxiColumnModule,
  DxiItemModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoRowDraggingModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
  DxoToolbarModule,
} from 'devextreme-angular/ui/nested';
import { ColConfig } from '../../interfaces/col-config';
import { GridConfigService } from '../../services/grid-config.service';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-cols-part-one',
  templateUrl: './sia-grid-config-cols-part-one.component.html',
  styleUrls: ['./sia-grid-config-cols-part-one.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigColsPartOneComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxoRowDraggingModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    DxoToolbarModule,
    DxiItemModule,
    DxTemplateModule,
    DxButtonModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigColsPartOneComponent
  extends SiaGridConfigTab
  implements OnDestroy
{
  private gridConfig = inject(GridConfigService);
  private siaSession = inject(SiaSessionService);
  private sizeDetector = inject(SiaSizeDetectorService);

  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined | null;

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfig1');
    super.ngOnDestroy();
  }
  ngOnInit(): void {
    this.onReorder = this.onReorder.bind(this);
  }
  refreshConf = output<boolean>({ alias: 'refreshConf' });

  onReorder(e: any) {
    if (!this.gridConf) {
      return;
    }
    this.gridConf.cols = this.gridConf.cols.sort(
      (a, z) => (a.visibleIndex ?? 0) - (z.visibleIndex ?? 0),
    );
    const fromIndex = e.fromIndex;
    const toIndex = e.toIndex;
    const element = this.gridConf.cols.splice(fromIndex, 1)[0];
    this.gridConf.cols.splice(toIndex, 0, element);
    let visibleIndex = 10;
    this.gridConf.cols.forEach((element) => {
      element.visibleIndex = visibleIndex;
      visibleIndex += 10;
    });
    this.childDataGrid?.instance.refresh();
  }

  sortChanged(e: any) {}
  onInitNewRow(e: any) {
    var row: ColConfig = e.data;
    row = {
      //prima pagina
      dataField: 'columnName',
      primaryKey: false,
      caption: 'Visible name',
      dataType: '',
      visibleIndex: 999,
      width: '',
      format: '',
      alignment: 'left',
      hidingPriority: undefined,
      allowEditing: false,
      visible: true,
      //seconda pagina
      cellEditor: '',
      cellTemplate: '',
      //terza pagina
      allowHiding: true,
      showInColumnChooser: true,
      selectedFilterOperation: '',
      allowHeaderFiltering: false,
      allowSorting: true,
      sortOrder: '',
      sortIndex: 0,
      summaryColGroupEnable: false,
      summaryColEnable: false,
      summaryType: '',
      alignByColumn: true,
    };
    e.data = row;
  }

  refreshConfiguration(e: any) {
    this.refreshConf.emit(true);
  }
}
